<template>

    <v-list style="padding: 24px 24px;">
        
        <v-list-item
            v-for="(item,index) in ruleItems"
            :key="item.id"
            style="margin-top: 20px;"
            class="d-flex justify-space-between mb-6"
        >
            <v-row align="center" justify="center">
                <v-icon color="green" class="mb-6" cols="auto" v-if="item.is_match !== null && item.is_match !== undefined && item.is_match">
                   mdi-check-circle-outline
                </v-icon>
                <v-icon color="red" class="mb-6" cols="auto" v-if="item.is_match !== null && item.is_match !== undefined && !item.is_match">
                    mdi-cancel
                </v-icon>
                <v-col cols="auto">
                    <v-chip
                        v-if="index === 0"
                        label
                        class="chip white--text"
                        color="#90CAF9"
                    >
                        當
                    </v-chip>
                    <v-chip v-else label class="chip white--text" color="#90CAF9">
                        且
                    </v-chip>
                </v-col>
                <v-col  cols="4.5">
                    <v-row align="center" justify="center">
                        <v-icon left style="flex-basis: 20px;">
                            {{ mode_icon(item.mode) }}
                        </v-icon>
                        
                        <v-list-item-title style="flex-basis: 10px; flex-grow: 1; flex-shrink: 1;">
                            {{ parseRuleStr( item.mode ,reverse_mapping_rule[item.pattern], item.value, item.pattern) }}
                        </v-list-item-title>
                    </v-row>    
                </v-col>

                <v-col class="d-flex flex-column">
                    <div v-for="chip in item.value" :key="chip">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-chip
                                    outlined 
                                    style="max-width: 300px;"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <span style="text-overflow: ellipsis; overflow: hidden; white-space: nowrap;"
                                        v-bind="attrs"
                                        v-on="on">
                                        {{ chip }}
                                    </span>
                                </v-chip>
                            </template>
                            <span>{{ chip }}</span>
                        </v-tooltip>
                    </div>
                </v-col>
                <v-col cols="auto">
                    <v-row>
                        <v-col>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        :style="{
                                            backgroundColor: 'transparent',
                                            boxShadow: 'none'
                                        }"
                                        @click="updateExperienceRule(item)"
                                        v-bind="attrs"
                                        v-on="on"
                                        :disabled="is_disabled"
                                    >
                                        <v-icon>
                                            mdi-pencil
                                        </v-icon>

                                    </v-btn>
                                </template>
                                <span>更新條件</span>
                            </v-tooltip>
                        </v-col>
                        <v-col>
                            <v-tooltip bottom>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                        :style="{
                                            backgroundColor: 'transparent',
                                            boxShadow: 'none'
                                        }"
                                        @click="deleteExperienceRule(item)"
                                        v-bind="attrs"
                                        v-on="on"
                                        :disabled="is_disabled"
                                    >
                                        <v-icon>
                                            mdi-trash-can
                                        </v-icon>

                                    </v-btn>
                                </template>
                                <span>刪除條件</span>
                            </v-tooltip>
                        </v-col>
                    </v-row>
                </v-col>
        </v-row>
                    
                
            </v-list-item>
            <v-list-item v-if="ruleItems.length > 0">
                <v-chip label class="chip white--text" color="#90CAF9">
                    且
                </v-chip>
                <v-btn
                    :style="{
                        color: 'rgb(26,115,232)',
                        backgroundColor: '#fff',
                        borderRadius: '3px',
                        boxShadow: 'none'
                    }"
                    class="priority_btn"
                    @click="createExperienceRule"
                    :disabled="is_disabled"
                >
                    + 新增網址規則
                </v-btn>
            </v-list-item>
    </v-list>
</template>

<script>

export default {
    props: {
        ruleItems: Array,
        default: [],
        experiment: Object
    },
    name: "ExperimentListWebRule",
    components: {

    },
    data() {
        return {
            mapping_rule: {
                // 規則
                '包含': 'in',
                '不包含': 'nin',
                '符合': 'mc',
                '不符合': 'nmc',
                '等於': 'eq',
                '不等於': 'neq',
                '開頭是': 'sw',
                '結尾是': 'ew',
                '開頭不是': 'nsw',
                '結尾不是': 'new',
                '與規則運算式相符': 'mr',
                '與規則運算式不符': 'nmr',
                '與規則運算式相符(忽略大小寫)': 'ri',
                '與規則運算式不符(忽略大小寫)': 'nri',
                // 網址
                '完整網址': 'url',
                '主機': 'host',
                '路徑': 'path',
                '網址片段': 'urlFragment',
            },
            reverse_mapping_rule: {
                // 規則
                'in': '包含',
                'nin': '不包含',
                'mc': '符合',
                'nmc': '不符合',
                'eq': '等於',
                'neq': '不等於',
                'sw': '開頭是',
                'ew': '結尾是',
                'nsw': '開頭不是',
                'new': '結尾不是',
                'mr': '與規則運算式相符',
                'nmr': '與規則運算式不符',
                'ri': '與規則運算式相符(忽略大小寫)',
                'nri': '與規則運算式不符(忽略大小寫)',
                // 網址
                'url': '完整網址',
                'host': '主機',
                'path': '路徑',
                'urlFragment': '網址片段'
            },
            selectedItem: null,
            local_rule_items: this.ruleItems
        }   
    },
    created() {
        console.log("qqqqqqqqqqqqqq",this.ruleItems);
    },
    mounted() {
        console.log("yo ExperimentList");
        console.log(this.ruleItems);
        console.log(this.local_rule_items);
    },
    computed: {
      is_disabled() {
        return (this.experiment.enable && this.experiment.is_release) || (this.experiment.enable === false && this.experiment.is_release)
      },
    
    },
    methods: {
        updateExperienceRule(item) {
            console.log(item);
            this.$emit('updateExperienceRule', item)
        },
        deleteExperienceRule(item) {
            console.log(item);
            this.$emit('deleteExperienceRule', item)
        },
        createExperienceRule() {
            this.$emit('createExperienceRule')
        },
        parseRuleStr(mode, ch, val, pattern) {
            console.log(mode);
            console.log(pattern);
            console.log(ch);
            console.log(val);
            if (val.length > 1) {
                return `  ${this.reverse_mapping_rule[mode]}${this.reverse_mapping_rule[pattern]}任一`
            }
            return `  ${this.reverse_mapping_rule[mode]}${this.reverse_mapping_rule[pattern]}`
        },
        mode_icon(mode) {
            let mdi_icon_text
            switch (mode) {
                case 'host':
                    mdi_icon_text = 'mdi-desktop-classic'
                    break;
                case 'url':
                    mdi_icon_text = 'mdi-earth'
                    break;
                case 'path':
                    mdi_icon_text = 'mdi-vector-line'
                    break;
                case 'urlFragment':
                    mdi_icon_text = 'mdi-format-header-pound'
                    break;    
                default:
                    break;
            }
            return mdi_icon_text
        }   
    },
    watch: {
        // ruleItems: {
        //     handler: function(newVal){
        //         console.log(newVal);
        //         this.ruleItems = JSON.parse(JSON.stringify(newVal))
        //         console.log(this.ruleItems.is_match);
        //     }
        // },
        // deep: true,
        // immediate: true
    }
}
</script>

<style scoped>
    .chip {
        height: 0.5em;
        width: 52px;
        line-height: 40px;
        padding: 19px;
        margin-right: 40px;
    }
</style>